import { CNCLathe } from "@/components/site/DecorativeBG";

function ImageCard({ src, alt, srcWebp }) {
  return (
    <div className="bg-white border border-gray-200 p-3 sm:p-5 lg:p-8 shadow-sm">
      <picture>
        {srcWebp && <source srcSet={srcWebp} type="image/webp" />}
        <img
          src={src}
          alt={alt}
          className="w-full h-auto"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </picture>
    </div>
  );
}

export default function Products() {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 lg:py-32 bg-brand-bg overflow-hidden"
    >
      <CNCLathe className="-bottom-12 lg:-bottom-16 -left-6 lg:left-8 hidden lg:block" opacity={0.18} tone="maroon" bounce />
      <div className="container-x relative">
        <div className="flex items-end justify-between flex-wrap gap-6 max-w-5xl mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-rule" />
              <span className="eyebrow">Products</span>
            </div>
            <h2 className="h-section">
              Parts we manufacture
              <br />
              <span className="text-brand-blue">&amp; export, every day.</span>
            </h2>
          </div>
          <p className="text-brand-text/70 max-w-md leading-relaxed">
            Representative components manufactured to customer drawings and
            delivered to OEMs across global markets.
          </p>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <span className="divider-rule" />
          <span className="eyebrow">Product Gallery</span>
        </div>
        <ImageCard
          src="/products-catalog.png"
          srcWebp="/products-catalog.webp"
          alt="Tirupati Global Sourcing Company — Electrical Industry and Machining Components catalog"
        />
      </div>
    </section>
  );
}
